/* Pause continuous CSS animations while their section is off-screen.
   Saves compositor work + battery without changing visible behaviour. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var els = document.querySelectorAll('.hero, .promo-spotlight, .feature-banner, .brand-strip-section');
  if (!els.length) return;
  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      entries[i].target.classList.toggle('anim-paused', !entries[i].isIntersecting);
    }
  }, { rootMargin: '120px 0px' });
  for (var i = 0; i < els.length; i++) io.observe(els[i]);
})();
